export function FromJSCollection<T>(
  rawJS: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor: (data: any) => T,
): T[] {
  const collection = Array<T>();
  const parsedJS = JSON.parse(rawJS);

  if (!parsedJS) {
    return collection;
  }

  for (const item of parsedJS) {
    collection.push(constructor(item));
  }

  return collection;
}
